if (!customElements.get('oyx-products-marquee')) {
  customElements.define('oyx-products-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = true;
      this.rows = [...this.querySelectorAll('[data-row]')].map(row => {
        const viewport = row.querySelector('[data-viewport]');
        const track = row.querySelector('[data-track]');
        const set = row.querySelector('[data-set]');
        const state = {row, viewport, track, set, hover: false, focus: false, dragging: false, moved: false, offset: 0};
        const clone = () => {
          const copy = set.cloneNode(true);
          copy.removeAttribute('data-set');
          copy.dataset.clone = '';
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a').forEach(a => a.tabIndex = -1);
          track.append(copy);
        };
        state.measure = () => {
          state.span = set.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          while (track.scrollWidth < viewport.clientWidth + state.span * 2) clone();
          viewport.scrollLeft = state.span + state.offset;
        };
        state.measure();
        viewport.addEventListener('mouseenter', () => state.hover = true, opts);
        viewport.addEventListener('mouseleave', () => state.hover = false, opts);
        viewport.addEventListener('focusin', () => state.focus = true, opts);
        viewport.addEventListener('focusout', () => state.focus = false, opts);
        viewport.addEventListener('pointerdown', e => {
          if (e.button !== 0) return;
          state.dragging = true; state.moved = false; state.x = e.clientX; state.start = viewport.scrollLeft;
        }, opts);
        window.addEventListener('pointermove', e => {
          if (!state.dragging) return;
          const delta = state.x - e.clientX;
          if (Math.abs(delta) > 6) {state.moved = true; viewport.classList.add('is-dragging');}
          if (state.moved) {viewport.scrollLeft = state.start + delta; state.offset = viewport.scrollLeft - state.span;}
        }, opts);
        window.addEventListener('pointerup', () => {state.dragging = false; viewport.classList.remove('is-dragging');}, opts);
        window.addEventListener('pointercancel', () => state.dragging = false, opts);
        viewport.addEventListener('click', e => {
          if (state.moved) {e.preventDefault();state.moved = false;return;}
          const card = e.target.closest('[data-clone] .oyx-products__card');
          if (card) location.assign(card.href);
        }, opts);
        return state;
      });
      this.resize = new ResizeObserver(() => this.rows.forEach(r => r.measure()));
      this.rows.forEach(r => this.resize.observe(r.viewport));
      this.intersection = new IntersectionObserver(entries => this.visible = entries[0].isIntersecting);
      this.intersection.observe(this);
      this.last = performance.now();
      const tick = now => {
        const delta = Math.min((now - this.last) / 1000, .05); this.last = now;
        if (!this.paused && !this.motion.matches && this.visible && !document.hidden) {
          this.rows.forEach(r => {
            if (r.hover || r.focus || r.dragging || !r.span) return;
            r.offset += delta * Number(this.dataset.speed || 35) * (r.row.dataset.direction === 'right' ? -1 : 1);
            r.offset = ((r.offset % r.span) + r.span) % r.span;
            r.viewport.scrollLeft = r.span + r.offset;
          });
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect();
      this.querySelectorAll('[data-clone]').forEach(el => el.remove());
    }
  });
}
